import Api from '../../api/Api'

const review = {
    // Set namespace true
    namespaced: true,

    state:{
        reviews: []
    },

    mutations: {
        SET_REVIEWS(state, data){
            state.reviews = data
        },
    },

    actions: {
        getReview({commit}){
            Api.get('/review').then(response => {
                commit('SET_REVIEWS', response.data.data.data)
            }).catch(error => {
                console.log(error)
            })
        }
    },

    getters:{}
}

export default review